import { getOpxHostApi } from 'owa-opx';
import type { SendScenarioDataPayload } from '../types/SendScenarioDataPayload';

export const sendScenarioDataToHost = <T = never>(data: SendScenarioDataPayload<T>) => {
    const opxHostApi = getOpxHostApi();
    opxHostApi?.sendScenarioData(data);
};
